import { createFileRoute } from "@tanstack/react-router";

import { LegalPage } from "@/components/LegalPage";
import { SITE_URL } from "@/lib/seo";
import { BRAND } from "@/lib/geo-config";

export const Route = createFileRoute("/impressum")({
  head: () => ({
    meta: [
      { title: "Impressum | Immobilienwert Online Zürich" },
      { name: "description", content: "Impressum und rechtliche Angaben der PartNET AG, Betreiberin von Immobilienwert Online Zürich." },
      { property: "og:title", content: "Impressum | Immobilienwert Online Zürich" },
      { property: "og:description", content: "Rechtliche Angaben und Kontaktinformationen der PartNET AG." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_URL}/impressum` },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/impressum` }],
  }),
  component: ImpressumPage,
});

function ImpressumPage() {
  return (
    <LegalPage eyebrow="Rechtliche Angaben" title="Impressum" intro="Angaben zur Betreiberin dieser Website und Kontaktmöglichkeiten.">
      <section>
        <h2>Betreiberin</h2>
        <address className="mt-4 not-italic">
          {BRAND.company}<br />
          {BRAND.street}<br />
          {BRAND.postalCode} {BRAND.city}<br />
          Schweiz
        </address>
        <p>
          Kontaktadresse: {BRAND.street}, {BRAND.postalCode} {BRAND.city}<br />
          Telefon: <a href="tel:+41445128512">+41 44 512 85 12</a><br />
          E-Mail: <a href="mailto:info@partnet.ch">info@partnet.ch</a>
        </p>
        <p>Vertretungsberechtigte Person: Mohamed Boulad, Verwaltungsrat</p>
      </section>

      <section>
        <h2>Handelsregister</h2>
        <p>Eingetragener Firmenname: PartNET AG<br />Handelsregister-Nr.: CHE-448.785.927</p>
      </section>

      <section>
        <h2>Haftungsausschluss</h2>
        <p>Die PartNET AG übernimmt keine Gewähr für die Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der bereitgestellten Informationen.</p>
        <p>Haftungsansprüche wegen materieller oder immaterieller Schäden, die aus dem Zugriff, der Nutzung oder Nichtnutzung der veröffentlichten Informationen, aus Missbrauch der Verbindung oder aus technischen Störungen entstehen, werden soweit gesetzlich zulässig ausgeschlossen.</p>
        <p>Alle Angebote sind unverbindlich. Die PartNET AG kann Inhalte ohne Ankündigung verändern, ergänzen oder entfernen sowie die Veröffentlichung zeitweise oder endgültig einstellen.</p>
      </section>

      <section>
        <h2>Externe Links</h2>
        <p>Für Inhalte externer Websites, auf die diese Website verweist, sind ausschliesslich deren Betreiber verantwortlich. Der Zugriff und die Nutzung erfolgen auf eigene Verantwortung.</p>
      </section>

      <section>
        <h2>Urheberrechte</h2>
        <p>Die Rechte an Inhalten, Bildern, Fotos und weiteren Dateien auf dieser Website liegen bei der PartNET AG oder den jeweils genannten Rechteinhabern. Die Vervielfältigung bedarf der vorherigen schriftlichen Zustimmung.</p>
      </section>
    </LegalPage>
  );
}